<template>
  <label :for="fieldContext.inputId" class="sr-only">
    <slot name="label" />
  </label>

  <slot />
</template>

<script lang="ts" setup>
import { toRef, useId } from "vue";

import { type ValidationStatus, provideFieldContext } from "./context";

const props = defineProps<{
  disabled?: boolean;
  validationStatus?: ValidationStatus;
}>();

const inputId = useId();

const fieldContext = provideFieldContext({
  inputId,
  descriptionId: `${inputId}-description`,
  hintId: `${inputId}-hint`,
  validationMessageId: `${inputId}-validation-message`,
  required: toRef(() => false),
  disabled: toRef(() => props.disabled ?? false),
  validationStatus: toRef(props, "validationStatus"),
});
</script>
